import netest from "netest";
import Bowser from "bowser";

navigator.getMedia =
  navigator.getUserMedia || // use the proper vendor prefix
  navigator.webkitGetUserMedia ||
  navigator.mozGetUserMedia ||
  navigator.msGetUserMedia ||
  navigator.mediaDevices.getUserMedia;

export const netestOptions = {
  slowSpeedThreshold: 100,
  numOfChecks: 3,
  failIfTooLong: true,
  timeUntilLoadFailure: 20000,
  loadFailureCheckInterval: 2000,
  imageSource:
    // "https://upload.wikimedia.org/wikipedia/commons/b/b9/Pizigani_1367_Chart_1MB.jpg",
    "https://media.geeksforgeeks.org/wp-content/cdn-uploads/20200714180638/CIP_Launch-banner.png",
  imageSize: 81.2,
};

export const initiateWebCam = () => {
  // Get access to the camera!
  return new Promise((resolve, reject) => {
    navigator.getMedia(
      { video: true },
      function (stream) {
        resolve(stream);
      },
      function (error) {
        console.log(error);
        reject("failure accessing camera");
      }
    );
  });
};

export const initiateMic = () => {
  // Get access to the camera!
  return new Promise((resolve, reject) => {
    navigator.getMedia(
      { audio: true, noiseSuppression: true },
      function (stream) {
        console.log("initiateMic", stream);
        resolve(stream);
      },
      function (error) {
        console.log(error);
        reject("failure accessing audio device");
      }
    );
  });
};

export const speedTest = () => {
  return netest(netestOptions);
  //  .then((result) => {
  //     if (!result.isSlow) console.log("Your internet is great!");
  //  })
  //  .catch((error) => {
  //     if (error.hasFailed) console.log("Too bad, your internet sucks...")
  //  });
};

export const browserTest = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);

  const isValidBrowser = browser.satisfies({
    // or in general
    chrome: ">=49",
    firefox: ">=50",
  });

  return new Promise((resolve, reject) => {
    if (isValidBrowser) {
      const { name } = browser.getBrowser();
      resolve(`${name} `);
    } else {
      reject(
        "failure matching required browsers pls use latest chrome or firefox"
      );
    }
  });
};

export const deriveNewContext = (contextKeeper, option) => {
  // Get access to the camera!
  return new Promise((resolve, reject) => {
    contextKeeper.getNewContext(option, (error, audioCtx) => {
      if (error) {
        reject(error);
      } else {
        resolve(audioCtx);
        // Do audio stuff here! Then:
        // Closes the current audio context and creates a new one.
      }
    });
  });
};
